/* eslint-disable dot-notation */

import toast from "react-hot-toast";

import queryString from "query-string";

import { SessionCrypto } from "./SessionService";
import { type ConnectRequest, type TonConnectParams } from "./types";

export function parseTonConnectConnection(options: { url: string }): TonConnectParams | string {
  try {
    const { query } = queryString.parseUrl(options.url);

    if (query["v"] !== "2") {
      throw Error(`Unknown protocol version: ${query["v"]}`);
    }

    if (typeof query["id"] !== "string") {
      throw Error("missing id " + options.url);
    }

    if (typeof query["r"] !== "string") {
      throw Error("missing payload " + options.url);
    }

    const protocolVersion = parseInt(query["v"], 10);
    const request = JSON.parse(decodeURIComponent(query["r"])) as ConnectRequest;
    const clientSessionId = query["id"];
    const sessionCrypto = new SessionCrypto();
    const needReturnBack = query["ret"] === "back";

    return {
      protocolVersion,
      request,
      clientSessionId,
      sessionKeyPair: sessionCrypto.stringifyKeypair(),
      needReturnBack,
    };
  } catch (e) {
    if (e instanceof Error) {
      return e.message;
    }
    return "Unknown Error";
  }
}

export const parseTonConnectUrl = (url: string) => {
  try {
    const params = parseTonConnectConnection({ url });

    if (typeof params === "string") {
      console.error(params);
      throw new Error("Unsupported link");
    }

    return params;
  } catch (e) {
    toast.error(String(e));
    throw e;
  }
};
